import { createReducer, on } from '@ngrx/store';
import { setTimeDateRangeSelection, clearTimeDateRangeSelection } from './timeDateRangeSelection.actions';
import { initialTimeWeekState } from './timeDateRangeSelection.state';

export const timeDateRangeSelectionReducer = createReducer(
  initialTimeWeekState,
  on(setTimeDateRangeSelection, (state, { week }) => ({ ...state, timeDateRangeSelection : week })),
  on(clearTimeDateRangeSelection, state => ({ ...state, timeDateRangeSelection : null })),
);